/** The guest pre-check-in app's look (`bookingmgmt`), for the preview frame ONLY — the
 *  console's own navy and Inter stay everywhere else (DESIGN.md Navy-Is-The-Ground).
 *
 *  Each value is copied from the guest app; the comment names its source (paths under
 *  `bookingmgmt/src/`). `guestParity.test.ts` holds them to a sibling `bookingmgmt`
 *  checkout when one is there, so a guest-app change fails here instead of drifting. */

export const GUEST = {
  /** theme.js `palette.primary.main` */
  primary: '#007aff',
  /** theme.js `palette.secondary.main` */
  secondary: '#fa3f33',
  /** theme.js `palette.background.default` — the page behind the cards */
  pageBg: '#f4f6f8',
  /** theme.js `palette.success.main` (a guest's completed step) */
  successMain: '#007aff',
  /** theme.js `palette.success.light` (the success icon); Sidebar.js `LEAD_BOOKER_CHECKMARK_COLOR` */
  successLight: '#00cda6',
  /** theme.js `palette.incomplete.main` / `.text` — the "Not pre-checked-in" chip */
  incompleteBg: '#ffe4e6',
  incompleteText: '#fe3f35',
  /** DynamicFields.js: the required outline and "* Required" captions */
  error: '#FE3F35',
  /** Sidebar.js: a step with required fields missing */
  missingDot: '#FE3F3580',
  /** theme.js `components.MuiCheckbox` root colour */
  checkbox: '#999999',
  /** StyledTextField.js: outline, label and placeholder colours */
  inputBorder: '#EAECF0',
  label: '#999999',
  placeholder: '#DDDDDD',
  /** Sidebar.js `StyledNavLink &.active`; LanguageSelector.js button fill */
  activeNav: '#EAF4FF',
  /** App.css `.bordered-box` (a waiver) */
  boxBorder: '#e0e0e0',
  /** StyledButton.js hovers */
  buttonHover: '#0056b3',
  outlinedHover: '#F8FAFF',
  /** theme.js `shape.borderRadius` */
  radius: 12,
  /** StyledButton.js `borderRadius` */
  buttonRadius: 8,
  /** Layout.js `appBarHeight`, `drawerWidth`, the content's `maxWidth` */
  appBarPx: 64,
  sidebarPx: 290,
  maxWidthPx: 966,
  /** DynamicFields.js `CATEGORY_RADIO_THRESHOLD` / `CATEGORY_MULTISELECT_THRESHOLD`: a
   *  single-choice question is radios below 3 options, a select from 3; a multiple-choice
   *  one is checkboxes below 4, a multi-select from 4. */
  radioThreshold: 3,
  multiselectThreshold: 4,
  /** index.css `body` font stack; public/index.html loads Roboto 400 and 700 only. */
  font: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
} as const;

/** The widths the preview draws at: the guest layout from its `lg` breakpoint (two field
 *  columns, the sidebar beside the form) and a phone. */
export const DESKTOP_CANVAS_PX = 1024;
export const PHONE_CANVAS_PX = 390;
